'use client'

import { useState, useEffect } from 'react'

const SCROLL_SHOW = 400  // показывать кнопку после прокрутки вниз (px)

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    let lastY = window.scrollY ?? 0
    const onScroll = () => {
      const y = window.scrollY ?? document.documentElement.scrollTop
      // прячем у самого низа: иначе кнопка перекрывает ссылки в подвале
      const doc = document.documentElement
      const nearBottom = window.innerHeight + y >= doc.scrollHeight - 160
      // На телефоне кнопка 48 px лежала поверх правого края текста и закрывала партнёрские
      // ссылки (Welcome Pickups в taxi-in-georgia, ревью 30.09.2026). Показываем её, только
      // когда читатель листает вверх, — тогда он и ищет дорогу наверх.
      const scrollingUp = y < lastY - 4
      const scrollingDown = y > lastY + 4
      lastY = y
      if (!(y > SCROLL_SHOW) || nearBottom) { setVisible(false); return }
      if (window.innerWidth >= 768) { setVisible(true); return }
      if (scrollingUp) setVisible(true)
      else if (scrollingDown) setVisible(false)
    }

    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top"
      className={`
        gf-scroll-top
        fixed bottom-6 right-6 z-40
        flex h-12 w-12 items-center justify-center rounded-full
        bg-gray-800/80 backdrop-blur-sm text-white shadow-lg
        transition-all duration-300 ease-out
        hover:bg-gray-700/90 hover:scale-105
        focus:outline-none focus:ring-2 focus:ring-gray-600 focus:ring-offset-2
        ${visible ? 'opacity-100 pointer-events-auto translate-y-0' : 'opacity-0 pointer-events-none translate-y-2'}
      `}
    >
      <svg
        className="h-5 w-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
      </svg>
    </button>
  )
}
